module.exports = __webpack_public_path__ + "static/media/john-such-493478-unsplash-sm.06c2b4a0.jpg";